import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import HeaderCSS from "../css/Header.module.css";
import data from "../Data";

function Header() {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLinkClick = (e, path) => {
    // Close mobile menu
    setMenuOpen(false);
    
    // If clicking on Home and already on home page, scroll to top
    if (path === "/" && location.pathname === "/") {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  };

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuOpen && !event.target.closest(`.${HeaderCSS.container}`)) {
        setMenuOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [menuOpen]);

  // Prevent body scroll when menu is open on mobile
  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [menuOpen]);

  return (
    <div className={HeaderCSS.container}>
      {/* Hamburger Icon - Mobile Only */}
      <button 
        className={`${HeaderCSS.hamburger} ${menuOpen ? HeaderCSS.open : ''}`}
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label="Toggle menu"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      {/* Navigation Menu */}
      <nav className={`${HeaderCSS.nav} ${menuOpen ? HeaderCSS.mobileMenuOpen : ''}`}>
        <ul>
          <li>
            <Link to="/" onClick={(e) => handleLinkClick(e, "/")}>
              Home
            </Link>
          </li>
          <li>
            <Link to="/about" onClick={(e) => handleLinkClick(e, "/about")}>
              About
            </Link>
          </li>
          <li>
            <Link to="/talent" onClick={(e) => handleLinkClick(e, "/talent")}>
              Talent
            </Link>
          </li>
          <li>
            <Link to="/shows" onClick={(e) => handleLinkClick(e, "/shows")}>
              Shows
            </Link>
          </li>
          <li>
            <Link to="/crew" onClick={(e) => handleLinkClick(e, "/crew")}>
              Crew
            </Link>
          </li>
          <li>
            <Link to="/bookings" onClick={(e) => handleLinkClick(e, "/bookings")}>
              Bookings
            </Link>
          </li>
          <li>
            <Link to="/contact" onClick={(e) => handleLinkClick(e, "/contact")}>
              Contact
            </Link>
          </li>
        </ul>
      </nav>

      {/* Instagram Icon - Desktop Only */}
      {data.Instagram && (
        <a
          href={data.Instagram}
          target="_blank"
          rel="noreferrer"
          className={HeaderCSS.instagramIcon}
          aria-label="Follow us on Instagram"
          title="Follow us on Instagram"
        >
          <svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="3" width="18" height="18" rx="5" />
            <circle cx="12" cy="12" r="4.3" />
            <circle cx="17" cy="7" r="1.2" fill="currentColor" stroke="none" />
          </svg>
        </a>
      )}
    </div>
  );
}

export default Header;
